<template>
  <main class="productResourceStatics div-layout">
    <module-title title="资源统计" />
    <module-title title="">
      <el-form
        ref="afterSaleStatisticsForm"
        :model="searchForm"
        :inline="true"
        :rules="handleRules"
        hide-required-asterisk
        label-position="right"
        label-width="100px"
        class="flex align-c flex-b"
      >
        <section>
          <el-form-item label="设备SN号：" prop="deviceNo">
            <el-input
              v-model="searchForm.deviceNo"
              name="deviceNo"
              maxlength="20"
              placeholder="输入设备SN号"
              class="handle-form-input"
              clearable
            />
          </el-form-item>
          <el-form-item style="margin-left: 20px">
            <el-button
              type="primary"
              size="medium"
              icon="el-icon-search"
              @click="handleSearchFilter"
            >
              查询
            </el-button>
          </el-form-item>
        </section>
        <el-form-item label="起止日期：" prop="dateTime">
          <el-date-picker
            v-model="searchForm.dateTime"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="选择开始日期"
            end-placeholder="选择结束日期"
            :picker-options="datePickerOptions"
            @change="handleChangeDate"
          />
        </el-form-item>
      </el-form>
    </module-title>
    <el-tabs v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane
        v-for="item of sourcenNav"
        :key="item.id"
        :label="item.name"
        :name="item.id"
      >
        <table-list
          v-if="sourceList.length > 0"
          :table-data="sourceList"
          :props-table="propsTable"
          @getData="getInfo"
        />
      </el-tab-pane>
    </el-tabs>
  </main>
</template>

<script>
import TableList from './tableList.vue';

import { getNowFormatDate, getupFormatDate } from '@/utils/index';
// 获取API
import {
  getQueryNodeTree,
  getSourceList
} from '@/api/productOperation/mrDesk/statistics';

import { mapGetters } from 'vuex';
export default {
  name: 'LearnStatistics',
  components: {
    TableList
  },
  data() {
    return {
      activeName: '1',
      sourcenNav: [],
      sourceList: [],
      propsTable: {
        stageId: '1',
        listLoading: false // 表格刷新loading
      },
      init: {
        stageId: '',
        startDate: getupFormatDate(null, null, 1),
        endDate: getNowFormatDate()
      },
      code: 0,
      // 搜索表单
      startDate: '',
      searchForm: {
        startDate: getupFormatDate(null, null, 1),
        endDate: getNowFormatDate(),
        dateTime: [getupFormatDate(null, null, 1), getNowFormatDate()],
        deviceNo: ''
      },
      // 今天以前的选中一个月时间段，不包含今天
      datePickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.startDate = minDate.getTime();
          if (maxDate) {
            this.startDate = '';
          }
        },
        disabledDate: (time) => {
          const one = 30 * 24 * 3600 * 1000;
          const minTime = this.startDate;
          console.log(minTime);
          if (this.startDate !== '') {
            let maxTime = this.startDate + one;
            if (maxTime > new Date()) {
              maxTime = new Date();
            }
            // return time.getTime() > Date.now() - 8.64e7 && (time.getTime() > maxTime || time.getTime() < minTime);不包含当天的
            return (
              time.getTime() > maxTime ||
              time.getTime() < minTime ||
              time.getTime() > Date.now() - 8.64e6
            );
          } else {
            return time.getTime() > Date.now() - 8.64e6;
          }
        }
      },
      // form检测
      handleRules: {
        dateTime: [
          {
            required: true,
            message: '请选择起止日期',
            trigger: 'change'
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters(['currentProdeuctId'])
  },
  mounted() {
    this.getSource();
  },
  methods: {
    // 获取列表
    getSource() {
      getSourceList().then((res) => {
        this.sourcenNav = res.data;
        this.init.stageId = res.data[0].id;
        this.propsTable.stageId = res.data[0].id;
        this.activeName = res.data[0].id;
        // console.log(123);
        this.getInfo(this.init);
      });
    },
    // 获取列表
    getInfo(val) {
      if (!val.startDate || !val.endDate) {
        this.$message({
          type: 'warning',
          message: '起止日期不能为空！'
        });
        return;
      }
      let type = null;
      if (['1', '2', '3', '4'].includes(this.activeName)) {
        type = 1;
      } else {
        type = 2;
      }
      var option = {
        startDate: val.startDate,
        endDate: val.endDate,
        type,
        stageId: val.stageId,
        deviceNo: val.deviceNo || null
      };
      getQueryNodeTree(option)
        .then((res) => {
          this.propsTable.listLoading = false;
          this.sourceList = [];

          if (res.data === null || res.data === '' || res.data === 'undefind') {
            this.sourceList = [];
          } else {
            this.sourceList = res.data;
            this.propsTable.listLoading = false;
          }
        })
        .catch((err) => {
          this.$message({
            type: 'warning',
            message: '暂无数据'
          });
          this.propsTable.listLoading = false;
          console.log(err);
        });
    },
    handleTabClick(tab, event) {
      this.propsTable.stageId = tab.name;
      // this.init.stageId = tab.name;
      this.getInfo({
        stageId: this.propsTable.stageId,
        ...this.searchForm
      });
    },
    handleChangeDate(val) {
      if (val && val.length > 0) {
        this.searchForm.startDate = val[0];
        this.searchForm.endDate = val[1];
        this.getInfo({
          stageId: this.propsTable.stageId,
          ...this.searchForm
        });
      } else {
        this.searchForm.startDate = '';
        this.searchForm.endDate = '';
      }
    },
    // 日期改变
    startDateChange(val) {
      if (val) {
        this.getInfo({
          stageId: this.propsTable.stageId,
          ...this.searchForm
        });
      } else {
        this.searchForm.startDate = '';
      }
    },
    endDateChange(val) {
      if (val) {
        this.getInfo({
          stageId: this.propsTable.stageId,
          ...this.searchForm
        });
      } else {
        this.searchForm.endDate = '';
      }
    },
    // 条件查询
    handleSearchFilter() {
      this.getInfo({
        stageId: this.propsTable.stageId,
        ...this.searchForm
      });
    }
  }
};
</script>

<style lang="scss">
.productResourceStatics{
   .el-tabs__nav-wrap{
   padding-left: 20px !important;
  }
}
</style>
<style lang="scss" scoped>
.questionManage {
  padding-bottom: 20px;
}

.dialogMain {
  max-height: 470px;
  overflow-y: auto;
}
.link {
  color: #409eff;
  text-decoration: underline;
}
.edit-form-input {
  width: 150px;
}
.handle-form-input {
  width: 80%;
}

.upload-picture {
  float: right;
}

.picture-wrapper {
  width: 80%;
  height: 100px;
  margin-top: 10px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
}
</style>
